import { Component, OnInit } from '@angular/core';
import { EnvironmentService, EnvironmentViewModel } from './environments.service';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'my-package',
    template: `
<section class="container">
  <div class="header-wrapper">
    <h1>Overview</h1>
  </div>
  <div class="content-wrapper">
    @if (environments) {
      <table class="mdl-data-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>EcoEHS Compatible</th>
            <th>No Of Application Instances</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @for (env of environments; track env) {
            <tr>
              <td>{{env.Id}}</td>
              <td>{{env.Name}}</td>
              <td>{{env.AirswebCompatible}}</td>
              <td>{{env.NoOfApplications}}</td>
              <td>
                <a mat-raised-button class="mat-accent tableBtn" [routerLink]="['../edit', env.Id]">
                  <mat-icon>edit</mat-icon>
                </a>
                @if (env.NoOfApplications === 0) {
                  <a mat-raised-button class="mat-warn tableBtn">
                    <mat-icon>delete</mat-icon>
                  </a>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
</section>
`,
    imports: [MatButton, RouterLink, MatIcon]
})
export class EnvironmentOverviewComponent implements OnInit {
    environments: EnvironmentViewModel[];
    constructor(
        private service: EnvironmentService
    ) { }

    ngOnInit(): void {
        this.getEnvironments();
    }

    getEnvironments() {
        this.service
            .getEnvironments()
            .subscribe(
                envs => this.environments = envs
            );
    }
}